'use client';

import { c as _c } from "react/compiler-runtime";
import RoomCard, { convertRoomToRoomCardFormat } from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/RoomCard';
import { SearchContentType } from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/useWorldsSearch';
import ViverseWorldCard from '@/components/ViverseWorldCard';
import { useConfigsContext } from '@/context/ConfigsContext';
import { cn } from '@/lib/utils';
import { Room } from '@/services/cms';
type WorldsListItemProps = {
  world: Room;
  enablePagination: boolean;
  contentType: SearchContentType;
};
export default function WorldsListItem(t0) {
  const $ = _c(14);
  const {
    world,
    enablePagination,
    contentType
  } = t0;
  const {
    store
  } = useConfigsContext();
  const htcToken = store?.credentials?.htcToken;
  if (!enablePagination) {
    let t1;
    if ($[0] !== world) {
      t1 = convertRoomToRoomCardFormat(world);
      $[0] = world;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const room = t1;
    let t2;
    if ($[2] !== contentType || $[3] !== room) {
      t2 = <RoomCard room={room} contentType={contentType} />;
      $[2] = contentType;
      $[3] = room;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  const t1 = `/${world.hub_sid}`;
  const t2 = contentType !== "experiences" && "p-0";
  let t3;
  if ($[5] !== t2) {
    t3 = cn("h-auto", t2);
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = !htcToken;
  const t5 = contentType === "videos";
  let t6;
  if ($[7] !== contentType || $[8] !== t1 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== world) {
    t6 = <ViverseWorldCard info={world} href={t1} className={t3} imageClassName="aspect-video w-full object-cover" hideLiked={t4} hidePremiumBadge={false} cardType={contentType} disableAutoPreview={t5} />;
    $[7] = contentType;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = world;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}